import { render } from "./PretendardText.vue?vue&type=template&id=6d1f6af0&scoped=true"
import script from "./PretendardText.vue?vue&type=script&lang=js"
export * from "./PretendardText.vue?vue&type=script&lang=js"

import "./PretendardText.vue?vue&type=style&index=0&id=6d1f6af0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1f6af0"]])

export default __exports__